import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Theme } from '@mui/material'

export type DealIsAFitProps = ExtendableStyles & {
  fitReason?: string
}

const DealIsAFit = ({ fitReason, ...otherProps }: DealIsAFitProps) => {
  const { classes } = useStyles()

  const fitReasonHTML = `<span>${fitReason}</span>`

  return (
    <div className={classes.wrapper} {...otherProps}>
      <div dangerouslySetInnerHTML={{ __html: `${fitReasonHTML}` }}></div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'aliceblue',
    padding: '15px',
    borderRadius: '10px',
  },
  field: {
    marginBottom: spacing(2),
  },
}))

export default React.memo(DealIsAFit)
